import get from 'lodash/get';
import type { RxCollection, RxDocument } from 'rxdb';

export default function getPrimaryKeyFromDatabaseEntry<DocType>(
  entry: DocType | RxDocument<DocType>,
  rxCollection: RxCollection<DocType>,
): string {
  return get(entry, rxCollection.schema.primaryPath) as string;
}
